<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6">
        <lib-page-header-light page-title="EXPORTAR PARA EMPENHO" fa-icon="file-export"></lib-page-header-light>
      </div>
      <div class="col-md-6">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <button (click)="exportarCompras()" class="btn btn-sm btn-outline-success float-right">
          <i class="fa fa-file-export"></i> Exportar Empenho
        </button>
      </div>
    </div>
    <hr class="mt-1" />
    <div class="row">
      <div class="col-md-9 p-0">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
              aria-selected="true">Ordens de Fornecimento</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="selecionados-tab" data-toggle="tab" href="#selecionados" role="tab"
              aria-controls="selecionados" aria-selected="false">Selecionados</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="row  mt-2">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-eddy table-eddy-sm">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 5%;" class="text-center">Sel.</th>
                        <th scope="col" style="width: 10%;" class="text-center">Nº/Exercício</th>
                        <th scope="col" style="width: 10%;">Data</th>
                        <th scope="col" style="width: 30%;">Fornecedor</th>
                        <th scope="col" style="width: 10%;" class="text-center">Subelemento</th>
                        <th scope="col" style="width: 25%;">Requerente</th>
                        <th scope="col" style="width: 15%;" class="text-center">Vl. Total</th>
                        <th scope="col" style="width: 10%;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of lista" class="{{item.excluido ? 'linha-cancelada': ''}}">
                        <th class="text-center">
                          <p-checkbox [ngModel]="validSelect(item)" (ngModelChange)="selecionar(item, $event)"
                            [binary]="true"></p-checkbox>
                        </th>
                        <th scope="row" class="text-center">{{item.numero}}/{{item.exercicio.ano}}</th>
                        <td class="text-center">{{item.data_compra | date:'dd/MM/yyyy':'GMT'}}</td>
                        <td>
                          {{item.favorecido.nome}}
                        </td>
                        <td class="text-center">{{item.subelemento.codigo | mascarar : '0.0.00.00.00.000'}}</td>
                        <td>{{item.requerente?.nome}}</td>
                        <td class="text-center">
                          {{item.total_compra | number:'1.5-5'}}
                        </td>
                        <td>
                          <a [routerLink]="['/compras', item.id, 'visualizar']" routerLinkActive="router-link-active"
                            class="btn btn-sm btn-outline-secondary mr-2 float-right" target="_blank">
                            <img src="assets/img/global/zoom.png" alt="visualizar" height="18" width="18">
                          </a>
                        </td>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row float-right" *ngIf="lista && lista.length > 0">
              <div class="col-12">
                <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
                  (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="selecionados" role="tabpanel" aria-labelledby="selecionados-tab">
            <div class="row mt-2">
              <div class="col-md-12" *ngIf="selecionados && selecionados.length > 0">
                <div class="table-responsive">
                  <table class="table table-eddy">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 5%;" class="text-center">Sel.</th>
                        <th scope="col" style="width: 10%;" class="text-center">Nº/Exercicio</th>
                        <th scope="col" style="width: 10%;">Data</th>
                        <th scope="col" style="width: 30%;">Fornecedor</th>
                        <th scope="col" style="width: 10%;" class="text-center">Subelemento</th>
                        <th scope="col" style="width: 25%;">Requerente</th>
                        <th scope="col" style="width: 15%;" class="text-center">Vl. Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of selecionados" class="{{item.excluido ? 'linha-cancelada': ''}}">
                        <th class="text-center">
                          <p-checkbox [ngModel]="validSelect(item)" (ngModelChange)="selecionar(item, $event)"
                            [binary]="true"></p-checkbox>
                        </th>
                        <th scope="row" class="text-center">{{item.numero}}/{{item.exercicio.ano}}</th>
                        <td class="text-center">{{item.data_compra | date:'dd/MM/yyyy':'GMT'}}</td>
                        <td>
                          {{item.favorecido.nome}}
                        </td>
                        <td class="text-center">{{item.subelemento.codigo | mascarar : '0.0.00.00.00.000'}}</td>
                        <td>{{item.requerente?.nome}}</td>
                        <td class="text-center">
                          {{item.total_compra | number:'1.5-5'}}
                        </td>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 pr-0">
        <p-fieldset legend="Filtros">
          <div class="form-row">
            <div class="col-sm-12">
              <span class="float-right" style="cursor: pointer;" (click)="menucompra_.toggle($event)"><i
                  class="fa fa-plus text-success"></i> Adicionar Filtro</span>
              <p-menu #menucompra_ appendTo="body" [popup]="true" [model]="menuFiltros"></p-menu>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <ng-container *ngFor="let filtro of listaFiltros">
                  <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'Number'"
                    class="form-group">
                    <label [for]="filtro.coluna">{{filtro.titulo}}</label>
                    <input [id]="filtro.coluna" [name]="filtro.coluna" type="number" class="form-control"
                      [(ngModel)]="filtro.filtro1" [style]="{ width: 'calc(100% - 40px)', float: 'left' }">
                    <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger ml-1"
                      style="height: 36px; width: 36px;">
                      <i class="fa fa-close"></i>
                    </button>
                  </div>
                  <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'String'"
                    class="form-group">
                    <label [for]="filtro.coluna">{{filtro.titulo}}</label>
                    <input [id]="filtro.coluna" [name]="filtro.coluna" type="String" class="form-control"
                      [(ngModel)]="filtro.filtro1" [imask]="filtro.mask ? {mask: '0000/0000' } : null" [unmask]="true"
                      [style]="{ width: 'calc(100% - 40px)', float: 'left' }">
                    <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger ml-1"
                      style="height: 36px; width: 36px;">
                      <i class="fa fa-close"></i>
                    </button>
                  </div>
                  <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'Date'"
                    class="form-group">
                    <div class="form-row">
                      <div class="col-sm-12">
                        <label [for]="filtro.coluna">{{filtro.titulo}} Início</label>
                        <p-calendar [id]="filtro.coluna" [(ngModel)]="filtro.filtro1" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                          [showButtonBar]="true" [style]="{ width: '100%' }">
                        </p-calendar>
                      </div>
                      <div class="col-sm-10 mt-2">
                        <label [for]="filtro.coluna">{{filtro.titulo}} Fim</label>
                        <p-calendar [id]="filtro.coluna" [(ngModel)]="filtro.filtro2" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                          [showButtonBar]="true" [style]="{ width: '100%' }">
                        </p-calendar>
                      </div>
                      <div class="col-sm-2 text-center d-flex justify-content-end align-items-end">
                        <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger"
                          style="height: 36px; width: 36px;">
                          <i class="fa fa-close"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-6 offset-sm-6">
              <button class="btn btn-sm btn-primary float-right" (click)="preencherGrid()">Buscar</button>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
</div>